import { Box, Flex, Image, Text, Badge } from "@chakra-ui/react"; // ⬅️ added Badge
import Translate from "../../components/LanguageTranslation/Translate";
import { useCurrency } from "../CurrencyExchange/CurrencyContext";
import countries from "i18n-iso-countries";

const TripsList = ({ trips, setSelectedTrip }) => {
  const { convertCurrency, currency } = useCurrency();

  // Console log country names from all trips
  // console.log("All trips:", trips);
  trips.forEach((trip, index) => {
    const countryName = trip?.general_info?.destinations?.[0]?.country;
    console.log(`Trip ${index + 1} country:`, countryName);
  });

  const countryFlagLink = (countryName) => {
    // console.log("Country name for flag:", countryName);
    const countryCode = countryName
      ? countries.getAlpha2Code(countryName, "en")
      : null;
    // console.log("Country code:", countryCode);
    return countryCode
      ? `https://flagcdn.com/w320/${countryCode.toLowerCase()}.png`
      : "../assets/images/banner.jpg";
  };

  const getTripImage = (trip) => {
    const firstDayImage =
      trip?.general_info?.destinations?.[0]?.trip_plan?.itinerary?.[0]
        ?.activity_detail_list?.[0]?.images?.[0]?.variants?.[2]?.url;
    return (
      firstDayImage ||
      countryFlagLink(trip?.general_info?.destinations?.[0]?.country)
    );
  };

  return (
    <Box flex="1" overflowY="auto" p={4} pl={6} height="100vh">
      {trips.map((x, index) => (
        <Box
          key={index}
          p={4}
          mb={3}
          cursor="pointer"
          bg="blackAlpha.50"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          onClick={() => setSelectedTrip(x._id)}
          position="relative"
        >
          {/* STATUS BADGE */}
          <Badge
            position="absolute"
            top={{ base: 2, md: 2 }}
            right={{ base: 2, md: 2 }}
            px={3}
            py={1}
            bg="none"
            color="#286328"
            border="1px solid"
            borderColor="#286328"
            borderRadius="md"
            textTransform="capitalize"
            fontSize="xs"
            fontWeight="bold"
            mb={2}
          >
            <Translate text={x.status || "Unknown"} />
          </Badge>

          {/* CARD CONTENT */}
          <Flex align="center" justify="space-between" width="100%">
            <Image
              src={getTripImage(x)}
              alt={x.trip_plan?.trip_name}
              boxSize="100px"
              borderRadius="md"
              mr={4}
            />

            <Flex
              direction={{ base: "column", md: "row" }}
              align="center"
              justify="space-between"
              w="100%"
              gap={2}
            >
              {/* Trip Name */}
              <Text
                fontSize="lg"
                fontWeight="bold"
                noOfLines={1}
                mt={{ base: 6, md: 0 }}
                mb={{ base: 1, md: 0 }}
                flex={{ md: 1 }}
              >
                <Translate text={x.general_info?.itinerary?.trip_name} />
              </Text>

              {/* Budgets */}
              <Box display="flex" flexDirection="row" gap={{ base: 0, md: 8 }}>
                <Text mb={0}>
                  <Text as="span" fontWeight="bold" mb={0}>
                    <Translate text="Total Budget: " />
                  </Text>
                  {currency + " "}
                  {convertCurrency(x.total_budget, "USD") &&
                  !isNaN(convertCurrency(x.total_budget, "USD"))
                    ? Number(convertCurrency(x.total_budget, "USD")).toFixed(2)
                    : "0.00"}
                </Text>

                <Text mb={0}>
                  <Text as="span" fontWeight="bold" mb={0}>
                    <Translate text="Daily Budget: " />
                  </Text>
                  {currency + " "}
                  {convertCurrency(x.daily_budget, "USD") &&
                  !isNaN(convertCurrency(x.daily_budget, "USD"))
                    ? Number(convertCurrency(x.daily_budget, "USD")).toFixed(2)
                    : "0.00"}
                </Text>
              </Box>
            </Flex>
          </Flex>
        </Box>
      ))}
    </Box>
  );
};

export default TripsList;
